import moment, { Moment } from "moment";
import { UrlProvider } from "./Providers";

export const API_BASE_URI = "/api";

export const API_CONGESTION_BASE_URI = `${API_BASE_URI}/congestion`;

export const API_CONGESTION_HIGHWAY_BASE_URI = `${API_CONGESTION_BASE_URI}/highways`;
export const API_CONGESTION_ARTERIAL_BASE_URI = `${API_CONGESTION_BASE_URI}/arterials`;
export const API_CONGESTION_LINKS_BASE_URI = `${API_CONGESTION_BASE_URI}/links`;
export const API_CONGESTION_FORECAST_BASE_URI = `${API_CONGESTION_BASE_URI}/forecast`;

//Insights provider
export const API_INSIGHTS_BASE_URI = `${API_BASE_URI}/insights`;

export const API_INSIGHTS_CONGESTION_BASE_URI = `${API_INSIGHTS_BASE_URI}/congestion`;
export const API_INSIGHTS_TRANSIT_BASE_URI = `${API_INSIGHTS_BASE_URI}/transit`;

// Forecast Url Providers
export class ForecastUrlProvider extends UrlProvider {
  getStreetInfoUrl() {
    return this.basePath;
  }

  getForecastForLink(linkId: string, ts: moment.Moment = moment().subtract(2.5, 'hour')) {
    return `${this.basePath}/${linkId}?ts=${ts.toISOString()}`;
  }
}

export const ForecastApiUrlProvider: ForecastUrlProvider = new ForecastUrlProvider(API_CONGESTION_FORECAST_BASE_URI);

// Traffic Url Providers
export class TrafficUrlProvider extends UrlProvider {
  getStreetInfoUrl() {
    return this.basePath;
  }

  getStreetDetailsUrl(streetName: string) {
    return `${this.basePath}/${streetName}`;
  }

  getStreetTimeseriesUrl(streetName: string) {
    return `${this.basePath}/${streetName}/timeseries`;
  }
}

export const CongestionApiUrlProvider: TrafficUrlProvider = new TrafficUrlProvider(API_CONGESTION_BASE_URI);
export const HighwayApiUrlProvider: TrafficUrlProvider = new TrafficUrlProvider(API_CONGESTION_HIGHWAY_BASE_URI);
export const ArterialApiUrlProvider: TrafficUrlProvider = new TrafficUrlProvider(API_CONGESTION_ARTERIAL_BASE_URI);

// Link Url Provider
export class LinksUrlProvider extends UrlProvider {
  getLinksUrl(datetime: Date | Moment | null = null) {
    let url = this.basePath;
    if (datetime) {
      url += `?datetime=${datetime.format("YYYY-MM-DD")}`;
    }
    return url;
  }

  getAllLinksUrl(representation: string, format: string, datetime: Date | Moment | null = moment()) {
    return `/api/links?representation=${representation}&format=${format}&datetime=${datetime.format('YYYY-MM-DD')}`;
  }

  getLinkInfoUrl(linkId: string, datetime: Date | Moment | null = null) {
    let url = `${this.basePath}/${linkId}`;
    if (datetime) {
      url += `?datetime=${datetime.toISOString()}`;
    }
    return url;
  }

  getLinkDataUrl(linkId: string,
    from: Date | Moment = moment().subtract(3, 'hours'), until: Date | Moment = moment()) {
    return `${this.basePath}/${linkId}/timeseries?from=${from.toISOString()}&until=${until.toISOString()}`;
  }
}
export const LinksApiUrlProvider: LinksUrlProvider = new LinksUrlProvider(API_CONGESTION_LINKS_BASE_URI);

// Insights Url Provider
export class InsightsUrlProvider {
  constructor(basePath) {
    this.basePath = basePath;
  }

  getInsightsInfoUrl() {
    return this.basePath;
  }
}

export const InsightsCongestionUrlProvider: InsightsUrlProvider = new InsightsUrlProvider(
  API_INSIGHTS_CONGESTION_BASE_URI
);
export const InsightsTransitUrlProvider: InsightsUrlProvider = new InsightsUrlProvider(
  API_INSIGHTS_TRANSIT_BASE_URI
);